import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  isLoading = false;

  attachLoader<T>(): (source: Observable<T>) => Observable<T> {
    return tap<T>({
      subscribe: () => (this.isLoading = true),
      next: () => (this.isLoading = false),
    });
  }
}
